import {addDays} from 'date-fns'

import {businessCalendarDate} from 'src/api/business-time'
import {parseApiDate, toApiDateString} from 'src/jobs/job-schedule-format'

import type {UnassignedJob} from './types'

const OPEN_ENDED_BOOKING_DAYS = 14
const MAX_BOOKING_DAYS = 31

/** Job dates from the later of today and the start date, capped at the end date or a fixed window. */
export function bookingDayOptions(job: UnassignedJob, today = businessCalendarDate()): string[] {
    const schedule = job.schedule
    if (!schedule || schedule.endDate === schedule.startDate) {
        return []
    }

    const todayString = toApiDateString(today)
    const first = schedule.startDate < todayString ? todayString : schedule.startDate
    const limit = schedule.endDate == null ? OPEN_ENDED_BOOKING_DAYS : MAX_BOOKING_DAYS
    const days: string[] = []
    for (let index = 0; index < limit; index += 1) {
        const day = toApiDateString(addDays(parseApiDate(first), index))
        if (schedule.endDate != null && day > schedule.endDate) {
            break
        }
        days.push(day)
    }
    return days
}
